import { useState, useEffect } from 'react';
import api from '@/services/api';

export default function DebugAuth() {
    const [tokenInfo, setTokenInfo] = useState<any>(null);
    const [testResult, setTestResult] = useState<any>(null);

    useEffect(() => {
        // Token bilgilerini al
        const token = localStorage.getItem('authToken');
        const user = localStorage.getItem('authUser');
        
        setTokenInfo({
            hasToken: !!token,
            tokenLength: token?.length,
            tokenPreview: token ? `${token.substring(0, 20)}...${token.substring(token.length - 20)}` : null,
            user: user ? JSON.parse(user) : null,
        });
    }, []);

    const testAdminEndpoint = async () => {
        try {
            const response = await api.get('/admin/taxonomy');
            setTestResult({
                success: true,
                status: response.status,
                data: response.data,
            });
        } catch (error: any) {
            setTestResult({
                success: false,
                status: error.response?.status,
                error: error.response?.data || error.message,
                headers: error.config?.headers,
            });
        }
    };

    return (
        <div className="p-8">
            <h1 className="text-2xl font-bold mb-6">🔍 Auth Debug</h1>
            
            <div className="space-y-6">
                {/* Token Info */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-4">Token Bilgileri</h2>
                    <pre className="bg-gray-100 p-4 rounded text-sm overflow-auto">
                        {JSON.stringify(tokenInfo, null, 2)}
                    </pre>
                </div>

                {/* Test Button */}
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-semibold mb-4">Endpoint Testi</h2>
                    <button
                        onClick={testAdminEndpoint}
                        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                    >
                        Test /admin/taxonomy
                    </button>
                </div>

                {/* Test Result */}
                {testResult && (
                    <div className="bg-white p-6 rounded-lg shadow">
                        <h2 className="text-lg font-semibold mb-4">Test Sonucu</h2>
                        <div className={`p-4 rounded ${testResult.success ? 'bg-green-100' : 'bg-red-100'}`}>
                            <p className="font-semibold mb-2">
                                Status: {testResult.status}
                            </p>
                            <pre className="bg-white p-4 rounded text-sm overflow-auto">
                                {JSON.stringify(testResult, null, 2)}
                            </pre>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
